export default {
    resources:      { method: 'get',    url: 'resources' },
    createResource: { method: 'post',   url: 'resources'},
    updateResource: { method: 'put',    url: 'resources/{id}'},
    deleteResource: { method: 'delete', url: 'resources/{id}'}
}